import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const msg = this.state.error && this.state.error.message
        ? this.state.error.message
        : String(this.state.error);
      return (
        <div style={{ padding: 32, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
          <h2>Algo salió mal</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>{msg}</p>
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              padding: '10px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#1976d2',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
